import React from "react";
import T from "prop-types";
import { get } from "lodash";
import { Map } from "immutable";
import { dollars } from "LIB/formatters/currency";
import { withFormFields } from "MODULES/shared/decorators";
import * as F from "MODULES/shared/components/Forms/FormTypes";
import {
  EXCHANGE_SALE,
  EXCHANGE_TYPE,
  THIRD_EXCHANGE,
  THIRD_EXCHANGE_PERCENT
} from "MODULES/SalesOrders/constants";
import { useSettings } from "APP_ROOT/hooks/useCurrentUser";
import { EXCHANGE_CREDIT_PCT } from "APP_ROOT/constants";
import { EXCHANGE_FEE } from "MODULES/OutgoingQuotes/constants";

const calculateInventoryCost = (
  exchangeSale,
  exchangeType,
  exchangeFee,
  totalCost,
  lineItemPricePerUnit
) => {
  const settings = useSettings();
  if (exchangeSale) {
    const exchangePercent =
      exchangeType === THIRD_EXCHANGE
        ? THIRD_EXCHANGE_PERCENT
        : get(settings, EXCHANGE_CREDIT_PCT, 50) / 100.0;
    return exchangeFee * exchangePercent;
  }

  return lineItemPricePerUnit || totalCost;
};

export function Cost({ inventory, lineItem, ...fields }) {
  const {
    exchange_sale: { input: { value: exchangeSale = false } },
    exchange_fee: { input: { value: exchangeFee } }
  } = fields;

  const exchange =
    exchangeSale === undefined ? lineItem.get(EXCHANGE_SALE) : exchangeSale;
  const label = exchange ? "Exch. Cost:" : "Cost at Time of Sale:";
  const fee = exchangeFee || lineItem.get(EXCHANGE_FEE);

  return (
    <p>
      {label}{" "}
      {dollars(
        calculateInventoryCost(
          exchange,
          lineItem.get(EXCHANGE_TYPE),
          fee,
          inventory.get("total_cost"),
          lineItem.get("cost_per_unit")
        )
      )}
    </p>
  );
}

Cost.propTypes = {
  lineItem: T.instanceOf(Map).isRequired,
  inventory: T.instanceOf(Map).isRequired,
  exchange_sale: F.formField(F.boolInput).isRequired,
  exchange_fee: F.formField(F.malleable).isRequired
};

export default withFormFields(Cost, [EXCHANGE_SALE, EXCHANGE_FEE]);



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Body/LineItems/Form/Summary/Cost.jsx